export default __webpack_public_path__ + "static/media/ic_send_primary.7448abf0.svg";